import { IMinimumPriceCalculation } from '@/types/simo/products';
import { IMinimumPriceCalculationCms } from '@/types/simo/product';

import {
  bodyTextRenderOptionsExtraSpacingBotttom,
  getAllEntriesFromResource,
  legalTextRenderOptions
} from '@/contentful/helper';
import { getPrices } from '@/utils/listPrice';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import React from 'react';
import './_minimumPriceModal.scss';

interface IProps {
  subscription: IMinimumPriceCalculation;
  minimumPriceCalculationCms: IMinimumPriceCalculationCms;
}
interface ITextsFromCms {
  sectionTitleAbonnementer: string;
  sectionTitleOneTimePrice: string;
  legalText: string;
}

const MinimumPriceModal = (props: IProps) => {
  const {
    recurringEntries,
    recurringTotal,
    oneTimeEntries,
    oneTimeEntriesTotal,
    total
  } = props.subscription;
  const { minimumPriceCalculationCms } = props;

  /* This is not working for extracting legal text because "getAllEntriesFromResource" is not able to 
  get deeply nested json from rich text fields in contentful*/

  const getTextsFromCms = getAllEntriesFromResource(
    minimumPriceCalculationCms.sectionTitleCollection.items
  ) as ITextsFromCms;

  const legalText = minimumPriceCalculationCms.sectionTitleCollection.items.find(
    (item) => item.key === 'legalText' || item.key === 'legalTextWithCampaign'
  );

  const legalTextContent = legalText ? legalText?.value?.json : '';
  return (
    <div>
      <div className="min-price-modal__title"> {minimumPriceCalculationCms.heading.title}</div>
      <div className="min-price-modal__subtitle">
        {documentToReactComponents(
          minimumPriceCalculationCms.heading.bodyText.json,
          bodyTextRenderOptionsExtraSpacingBotttom
        )}
      </div>
      <div className="min-price-modal__section__title">
        {getTextsFromCms.sectionTitleAbonnementer}
      </div>
      {recurringEntries.map((entry) => {
        return (
          <>
            {getPrices(
              entry,
              'min-price-modal__section__price',
              'min-price-modal__section__greyed-out-price',
              'min-price-modal__section__sublines'
            )}
          </>
        );
      })}
      {/* Abonnementer i alt */}
      {getPrices(
        recurringTotal,
        'min-price-modal__section__total-price',
        'min-price-modal__section__greyed-out-price'
      )}
      {/* ENGANGSBELØB */}
      <div className="min-price-modal__section__title">
        {getTextsFromCms.sectionTitleOneTimePrice}
      </div>
      {oneTimeEntries.map((entry) => {
        return (
          <>
            {getPrices(
              entry,
              'min-price-modal__section__price',
              'min-price-modal__section__greyed-out-price'
            )}
          </>
        );
      })}
      {/* Engangsbeløb i alt*/}
      {getPrices(
        oneTimeEntriesTotal,
        'min-price-modal__section__total-price',
        'min-price-modal__section__greyed-out-price'
      )}
      {/* Mindstepris - 1 md */}
      {getPrices(
        total,
        'min-price-modal__section__total-price min-price-modal__section__total-price--border',
        'min-price-modal__section__greyed-out-price'
      )}
      <div className="d-flex">
        <div className="flex-grow-1">
          {documentToReactComponents(legalTextContent, legalTextRenderOptions)}
        </div>
      </div>
    </div>
  );
};

export default MinimumPriceModal;
